import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios'
import { connect } from 'react-redux';
import { Row, Col, Radio, Card, Divider, Button, Popconfirm, Icon } from 'antd';
import 'antd/dist/antd.css';
import '../App.css'
import moment from 'moment';
import NumberFormat from 'react-number-format';


class Help extends Component {

    render() {
        return (
            <div>
                <div style={{ background: '#00abff'}}>
                    <Row>
                        <Col md={{span: 24}}>
                            <h1 style={{color: "#ffffff", margin: "12px", textAlign: 'center', fontWeight: 'bold'}}>You need help?</h1>
                        </Col>
                    </Row>
                </div>
                <div style={{ paddingTop: '24px' }}>
                                <Row gutter={16}>
                                    <Col md={{ span: 18, offset: 3 }}>
                                        <Card>
                                            <Row>
                                                <Col md={{ span: 24 }}>
                                                    <h1 style={{ fontWeight: "bold", color: '#0099ff' }}>
                                                        We are ready to help you...
                                                    </h1>
                                                    <br/>
                                                    <h2>
                                                        <Icon type="phone" theme="twoTone" />&nbsp; 
                                                        Reach out to us on:  +256 702 016 262, +256 706 269 654, +256 780 228 161, +256 777 184 393, 
                                                    </h2>
                                                    <br/>
                                                    <h2>
                                                        <Icon type="mail" theme="twoTone" /> &nbsp;
                                                        Send us an email on:  <a href="mailto: villarideltd@gmail.com?subject=Villaride Help needed">villarideltd@gmail.com </a>
                                                    </h2>
                                                </Col>
                                            </Row>

                                        </Card>
                                    </Col>
                                    </Row>
                </div>
            </div>
        );
    }
}


export default Help;
